import { Outlet } from 'react-router'
import { SiteNavbar } from '#app/components/site-navbar.tsx'

export default function AuthLayout() {
	return (
		<div className="bg-surface-0 flex min-h-screen flex-col">
			<SiteNavbar showAuthCta={false} />
			<div className="flex-1">
				<Outlet />
			</div>
		</div>
	)
}
